import { __assign, __rest } from "tslib";
import React from 'react';
import { cnAttach } from '../Attach.const';
import '../Reset/Attach-Reset.css';
// TODO: https://st.yandex-team.ru/ISL-6940
import '../IconFile/Attach-IconFile.css';
import './Attach-Holder.css';
export var Holder = function (_a) {
    var children = _a.children, className = _a.className, fileExtension = _a.fileExtension, fileName = _a.fileName, id = _a.id, onClearClick = _a.onClearClick, textWidth = _a.textWidth, props = __rest(_a, ["children", "className", "fileExtension", "fileName", "id", "onClearClick", "textWidth"]);
    return (React.createElement("span", __assign({}, props, { "aria-hidden": true, className: cnAttach('Holder', { file: fileExtension }, [className]) }),
        fileExtension && React.createElement("span", { className: cnAttach('IconFile') }),
        React.createElement("label", { style: { width: fileExtension && textWidth + "px" }, className: cnAttach('Text'), htmlFor: id }, fileName || children),
        fileExtension && React.createElement("span", { className: cnAttach('Reset'), onClick: onClearClick })));
};
